// Main Imports
import { createApp, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { appsignal } from "./appsignal.js";
import { errorHandler } from '@appsignal/vue'
import tooltip from '@/common/directives/tooltip';
import Popper from 'vue3-popper';

// Extra Plugin Import
import Notifications from '@kyvg/vue3-notification';
import vSelect from 'vue-select';
import 'bootstrap';

import { Laue } from 'laue';

// Font Awesome Imports
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faGraduationCap,
  faCheckCircle,
  faTimesCircle,
  faPaperPlane,
  faQuestionCircle,
  faSearch,
  faExclamationTriangle,
  faArrowLeft as fasArrowLeft,
  faChevronDown as fasChevronDown,
  faChevronRight as fasChevronRight,
  faChevronLeft as fasChevronLeft,
  faCircleX as fasCircleX,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCheck as farCheck,
  faEdit as farEdit,
  faEye as farEye,
  faChevronRight as farChevronRight,
  faChevronLeft as farChevronLeft,
  faUserPlus as farUserPlus,
  faCheckCircle as farCheckCircle,
  faChevronDown as farChevronDown,
  faChevronUp as farChevronUp,
  faEnvelope as farEnvelope,
  faDotCircle as farDotCircle,
  faCircle as farCircle,
  faSyncAlt as farSyncAlt,
  faFileExcel as farFileExcel,
  faFilePdf as farFilePdf,
  faAt as farAt,
  faLock as farLock,
  faTrash as farTrash,
  faClone as farClone,
  faUpload as farUpload,
  faDownload as farDownload,
  faUserChart as farUserChart,
  faCircleInfo as farCircleInfo,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowsUpDown as fadArrowsUpDown,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faGraduationCap as falGraduationCap,
  faCar as falCar,
  faGift as falGift,
  faChartBar as falChartBar,
  faUsers as falUsers,
  faArrowLeft as falArrowLeft,
  faArrowRight as falArrowRight,
  faExclamationTriangle as falExclamationTriangle,
  faTimesCircle as falTimesCircle,
  faTimes as falTimes,
  faPlus as falPlus,
  faMap as falMap,
  faSquare as falSquare,
  faCheckSquare as falCheckSquare,
  faCalendarCheck as falCalendarCheck,
  faCalendar as falCalendar,
  faDownload as falDownload,
} from '@fortawesome/pro-light-svg-icons';
// Font Awesome additions
library.add(faGraduationCap);
library.add(faCheckCircle);
library.add(faTimesCircle);
library.add(faPaperPlane);
library.add(faQuestionCircle);
library.add(faSearch);
library.add(faExclamationTriangle);
// Font Awesome Solid
library.add(fasChevronDown);
library.add(fasChevronRight);
library.add(fasChevronLeft);
library.add(fasArrowLeft);
library.add(fasCircleX);
// Font Awesome Regular
library.add(farCheck);
library.add(farEdit);
library.add(farEye);
library.add(farChevronRight);
library.add(farChevronLeft);
library.add(farChevronDown);
library.add(farChevronUp);
library.add(farUserPlus);
library.add(farCheckCircle);
library.add(farEnvelope);
library.add(farDotCircle);
library.add(farCircle);
library.add(farSyncAlt);
library.add(farFileExcel);
library.add(farFilePdf);
library.add(farAt);
library.add(farLock);
library.add(farTrash);
library.add(farClone);
library.add(farUpload);
library.add(farDownload);
library.add(farUserChart);
library.add(farCircleInfo)
// Font Awesome Light
library.add(falGraduationCap);
library.add(falCar);
library.add(falGift);
library.add(falChartBar);
library.add(falUsers);
library.add(falArrowLeft);
library.add(falArrowRight);
library.add(falExclamationTriangle);
library.add(falTimesCircle);
library.add(falTimes);
library.add(falPlus);
library.add(falMap);
library.add(falSquare);
library.add(falCheckSquare);
library.add(falCalendar);
library.add(falCalendarCheck);
library.add(falDownload);
// Duotone
library.add(fadArrowsUpDown);

// Style Imports
import './styles/main.scss';


// Create App
const pinia = createPinia();
const app = createApp(App);

// Appsignal

if (appsignal) {
  app.config.errorHandler = errorHandler(appsignal, app);
}

// Directives
app.directive('tooltip', tooltip);

// Components
app.component('BaseTable', defineAsyncComponent(() => import('@/common/components/base/table.vue')));
app.component('BasePagination', defineAsyncComponent(() => import('@/common/components/base/pagination.vue')))
app.component('BaseModal', defineAsyncComponent(() => import('@/common/components/base/modal.vue')))
app.component('FontAwesomeIcon', FontAwesomeIcon);
app.component('VSelect', vSelect);
app.component('Popper', Popper);

// Plugins
app.use(Notifications);
app.use(Laue);
app.use(pinia);



app
  .use(router)
  .mount('#app');

window.addEventListener('vite:preloadError', (event) => {
  window.location.reload();
});
// Global Events
export default app;
